let userLang = navigator.languages || [];
let currentLang = userLang.some(lang => lang.indexOf('ru') > -1) ? 'ru' : 'en';

let languagesArray = [
  'ru', 'en',
];

languagesArray.forEach( (language) => {
  if (window.location.origin === 'https://alfaleads.eu') return;

  if (currentLang === language &&
    !isCurrentURL(language) &&
    !getCookie('changeLang')
  ) {

    var d = new Date();
    d.setTime(d.getTime() + (24*60*60*1000));
    var expires = "expires="+d.toUTCString();

    var langPrefix = language=='ru' ? '' : language;
    document.cookie = "changeLang=" + language + ";path=/;"+expires;
    window.location.href = langPrefix + window.location.pathname.replace('/en/', '');
  }
})

function isCurrentURL(language) {
  let pageLang = window.location.pathname.split("/")[1]
  if (pageLang === '') {
    pageLang = 'ru';
  }
  return language == pageLang
}

function getCookie(name) {

  var matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));

  return matches ? decodeURIComponent(matches[1]) : undefined;
}
